import { FormatAlignCenterIcon } from './FormatAlignCenterIcon';

/**
 * author: Google
 * id 9B295DCA-8352-407E-84F1-34890975D010
 * name format-align-center
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-align-center.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatAlignCentreIcon = FormatAlignCenterIcon;
export default FormatAlignCentreIcon